import restService from './rest.service'
import moment from 'moment';

import formats from '../helpers/formats';

function getRegistros() {
    return restService.postAsync('app/getRegistros');
}

function getResultados(date) {
    return restService.postAsync('app/getResultados', date);
}

function getLaudo(atendimento) {
    return restService.downloadAsync(`app/getLaudo/${atendimento.ateCod}`, {
        mime: 'application/pdf',
        title: `Laudo_${atendimento.ateCod}_${moment().format('YYMMDDHms')}.pdf`
    })
}

function getResultadosFiltro(filtro) {
    return restService.postAsync('app/getResultadosFiltro', filtro);
}

function getPesquisaSatisfacao() {
    return restService.getAsync('app/getPesquisaSatisfacao');
}

function getPesquisaSatisfacaoPliq() {
    return restService.getAsync('app/getPesquisaSatisfacaoPliq');
}

export default { getRegistros, getResultados, getResultadosFiltro, getLaudo, getPesquisaSatisfacao, getPesquisaSatisfacaoPliq}